import IconInput from "components/elements/IconInput";
import Table from "components/elements/Table";
import { USER_TYPE_REVERSE } from "core/Constants";
import dataProvider from "core/DataProvider";
import utility from "core/Utils";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useOutletContext } from "react-router-dom";
const { default: Header } = require("../../common/Header");

const headers = {
  id: "Unique ID",
  name: "Name",
  email: "Email",
  username: "Username",
  login_time: "Login Time",
  user_type: "User Type",
  status: "Status",
  group: "Group",
  group_id: "Group ID",
  client: "Client",
  client_id: "Client ID",
};

const ActivityTracker = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const token = useOutletContext();
  const { name, client_name } = token;

  const getData = async () => {
    try {
      let data = await dataProvider.network.get("masters/userlogins");

      for (let i = 0; i < data.length; i++) {
        data[i].login_time = new Date(data[i].login_time).toLocaleString();
        data[i].user_type = USER_TYPE_REVERSE[data[i].user_type];
        data[i].status = data[i].status == 1 ? "Active" : "Inactive";
      }

      setData(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch user login details");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div id="activity-tracker" className="page">
      <Header user={name} client_name={client_name} title="Activity Tracker" />
      <section id="activity-tracker-container">
        <div className="box mtop">
          <div className="flex flex-v-center">
            <h3 className="pad-lr">User Logins</h3>
            <div className="right">
              <div className="el pad-lr">
                <IconInput
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="Search (min 3 character)"
                  icon="search"
                  style={{ minWidth: "250px" }}
                />
              </div>
            </div>
          </div>
          <div className="mtop">
            <Table headers={headers} data={data} search={search} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ActivityTracker;
